import get from 'lodash/get';
import { extractLotameInterestsFromGuideItem } from '../../utils/ads/lotameUtils';
import { sendLotameInterests } from '../mint';
import { showMessage } from '../messagePopover';
import { getFavoriteMessageText } from '../../utils/getFavoriteMessageText';
import isFollowingGuideId from '../../utils/isFollowingGuideId';
import { favoriteEffect } from '../favorites';
import { CATEGORIES } from '../../constants/containerTypes';
export default function makeFavoriteActions({ favoriteType, unFavoriteType }) {
  /**
   * creates an action which which makes the favorite call to
   * the favorites api to favorite a guideItem
   * @param guideItem
   * @param wasAuthenticated
   * @returns {object}
   */
  function favorite({ guideItem, wasAuthenticated }) {
    const guideId = get(guideItem, 'actions.follow.guideId');

    return favoriteEffect(favoriteType, guideId, { wasAuthenticated });
  }

  /**
   * creates an action which which makes the favorite call to
   * the favorites api to unFavorite a guideItem
   * @param guideItem
   * @param folder
   * @param index
   * @returns {object}
   */
  function unFavorite({ guideItem, folder, index }) {
    /**
     * Currently - 12/2020, there is an issue with the API, it returns an error of
     * "favoriteid or id is missing".
     * The id param is only being used by Categories, all else use the favoriteid
     * All items, except Categories have an actions.follow object
     * for this reason we pass the favoriteid when it's everything but a Category
     * and the guideId when it is.
     */
    const favoriteIdOrGuideId =
      get(guideItem, 'actions.follow.favoriteId') || get(guideItem, 'guideId');
    const guideId = get(guideItem, 'guideId');

    // Check to see if this is a Category, if so pass the guideId
    if (folder && folder.containerType && folder.containerType === CATEGORIES) {
      return favoriteEffect(unFavoriteType, guideId, { folder, index });
    }
    return favoriteEffect(unFavoriteType, favoriteIdOrGuideId, {
      folder,
      index,
    });
  }

  /**
   * creates an action which toggles favorite state of a guideItem
   * @param params
   * @param wasAuthenticated
   * @returns {Function}
   */
  function toggleFavorite(params, wasAuthenticated) {
    const { guideItem } = params;
    return (dispatch, getState) => {
      const state = getState();
      const meUserName = get(state, 'me.details.userName');
      if (
        meUserName &&
        guideItem.userName &&
        guideItem.userName === meUserName
      ) {
        return null;
      }

      const guideId = get(guideItem, 'guideId', '');
      const favoriteMessages = getFavoriteMessageText(guideId, state);
      const initialFollowState = get(
        guideItem,
        'actions.follow.isFollowing',
        false,
      );
      const isFollowing = isFollowingGuideId(
        state,
        guideId,
        initialFollowState,
      );

      if (!isFollowing) {
        dispatch(
          sendLotameInterests(extractLotameInterestsFromGuideItem(guideItem)),
        );
        return dispatch(favorite({ ...params, wasAuthenticated }))
          .then(({ value: { status } }) => {
            if (status === 200) {
              dispatch(showMessage(favoriteMessages.favorited));
            } else {
              dispatch(showMessage(favoriteMessages.favoriteError));
            }
          })
          .catch(() => {
            dispatch(showMessage(favoriteMessages.favoriteError));
          });
      }
      return dispatch(unFavorite(params))
        .then(({ value: { status } }) => {
          if (status === 200) {
            dispatch(showMessage(favoriteMessages.unFavorited));
          } else {
            dispatch(showMessage(favoriteMessages.unFavoriteError));
          }
        })
        .catch(() => {
          dispatch(showMessage(favoriteMessages.unFavoriteError));
        });
    };
  }

  return {
    favorite,
    unFavorite,
    toggleFavorite,
  };
}
